import cx from 'classnames'
import isEqual from 'lodash/isEqual'
import { useSelector } from 'react-redux'

import Styles from './TOCRail.module.scss'
import { CondensedTOC } from './CondensedTOC'
import { RootState } from 'types'
import { useDocHeadings } from './useDocHeadings'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'

export const TOCRail = observer(() => {
  const { showFocusMode } = useSelector(({ focusMode }: RootState) => focusMode, isEqual)
  const headingNodes = useDocHeadings()
  const rootStore = useRootStore()

  return (
    <div className={cx(Styles.container, { [Styles.hideToc]: rootStore.leftSidebarStore.isHovered })}>
      <div className={Styles.leftRailHoverArea}></div>
      <div
        className={cx(Styles.tocContainer, {
          [Styles.focusMode]: showFocusMode,
          [Styles.emptyToc]: !headingNodes.length,
        })}
      >
        <CondensedTOC />
      </div>
      <div className={Styles.leftRailHoverArea}></div>
    </div>
  )
})
